/**
 * Lightweight equivalent of Storyblok's storyblokEditable helper.
 *
 * Keeping this local prevents the full Storyblok browser SDK from being bundled
 * for published pages while preserving click-to-edit attributes in preview mode.
 */
export function storyblokEditable(blok?: unknown): Record<string, string> {
  if (!blok || typeof blok !== 'object' || !('_editable' in blok)) {
    return {};
  }

  const editableComment = (blok as { _editable?: unknown })._editable;

  if (typeof editableComment !== 'string') {
    return {};
  }

  try {
    const editable = JSON.parse(
      editableComment.replace(/^<!--#storyblok#/, '').replace(/-->$/, ''),
    ) as { id?: string | number; uid?: string };

    if (!editable) {
      return {};
    }

    return {
      'data-blok-c': JSON.stringify(editable),
      'data-blok-uid': `${String(editable.id ?? '')}-${String(editable.uid ?? '')}`,
    };
  } catch {
    return {};
  }
}
